import { useState, useEffect } from 'react';
import { useSupabaseClient, useSession } from '@supabase/auth-helpers-react';

export function useIsShopifyUser(): { isShopifyUser: boolean; isLoading: boolean } {
  const [isShopifyUser, setIsShopifyUser] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const supabase = useSupabaseClient();
  const session = useSession();

  useEffect(() => {
    if (!session?.user?.id) {
      setIsShopifyUser(false);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    supabase
      .from('user_profiles')
      .select('billing_provider')
      .eq('id', session.user.id)
      .maybeSingle()
      .then(({ data }) => {
        setIsShopifyUser(data?.billing_provider === 'shopify');
        setIsLoading(false);
      });
  }, [session?.user?.id, supabase]);

  return { isShopifyUser, isLoading };
}
